var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterSupplyBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "WS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #WS .cls-1 {\n        fill: #006cff;\n      }\n\n      #WS .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_385",
    "data-name": "Pfad 385",
    className: "cls-1",
    d: "M42,0A42,42,0,1,0,84,42,42.123,42.123,0,0,0,42,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1005",
    "data-name": "Gruppe 1005",
    transform: "translate(17.15 10.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_386",
    "data-name": "Pfad 386",
    className: "cls-2",
    d: "M43.05,7.7H25.2v4.9h-.7c-1.05,0-6.3,0-10.5,2.8s-8.75,7-9.1,18.9H16.8c0-10.5,6.3-10.15,8.05-10.15h0V26.6H42.7V24.15h5.25V12.6H42.7V7.7Zm3.15,7v7H40.6v2.45H27.65V21.7H24.5c-5.95,0-9.1,3.5-9.8,10.15h-7c.7-8.75,4.2-12.25,7.7-14.7a15.909,15.909,0,0,1,9.1-2.45h3.15V9.8H40.6v4.9h5.6Z",
    transform: "translate(-4.9 9.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1583",
    "data-name": "Rechteck 1583",
    className: "cls-2",
    width: 6.65,
    height: 23.8,
    transform: "translate(45.5 15.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_387",
    "data-name": "Pfad 387",
    className: "cls-2",
    d: "M12.05,10.25h6.3V16.9h4.2V10.25h6.3A1.653,1.653,0,0,0,30.6,8.5V7.45A1.653,1.653,0,0,0,28.85,5.7h-6.3V5a2.258,2.258,0,0,0-2.1-2.1A2.258,2.258,0,0,0,18.35,5V6.05h-6.3A1.653,1.653,0,0,0,10.3,7.8v.7A1.875,1.875,0,0,0,12.05,10.25Z",
    transform: "translate(8.6 -2.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_388",
    "data-name": "Pfad 388",
    className: "cls-2",
    d: "M5.3,25.25A4.633,4.633,0,0,0,9.85,29.8c2.45,0,4.9-2.1,4.9-4.55S10.2,15.8,10.2,15.8,5.3,22.8,5.3,25.25Z",
    transform: "translate(-3.9 29.35)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSupplyBigIcon);
export default __webpack_public_path__ + "static/media/water-supply-big-icon.7bd2697fe9c0c5fe1aa492eeb1a41415.svg";
export { ForwardRef as ReactComponent };